import { yup } from '@framework/validation/initYup.ts';
import { values } from 'lodash';
import { ExpressionType } from '../../IExpression.ts';
import { createExpressionType } from '../../IExpressionType.ts';
import { type IAsyncExpression } from './IAsyncExpression.ts';

export const AsyncExpressionType = createExpressionType<IAsyncExpression>({
  type: ExpressionType.Async,
  schema: yup.object({
    type: yup.string().exact(ExpressionType.Async).required(),
    serviceId: yup.string().label('Servizio').required(),
    inputs: yup.object().label('Parametri').required(),
    output: yup.string().label('Campo').required(),
  }),
  evaluate(expression, scope) {
    // TODO Supportare valutazione asincrona
    throw new Error('[AsyncExpression] Not implemented');
  },
  getReferences(expression, collect) {
    return values(expression.inputs).flatMap(collect);
  },
  toString(expression) {
    return `[AsyncService]`;
  },
});
